import React, {useEffect} from "react";
import Chart from "chart.js";
import { Line } from 'react-chartjs-2';

const SparklineGraph = (props) => {
    const {xaxis, yaxis, color} = props;

    useEffect(() => {
        // if (window.myChart !== undefined && window.myChart.destroy)
        // {
        //     window.myChart.destroy();
        // }

        // var ctx = document.getElementById('myChart').getContext('2d');
        // var gradient = ctx.createLinearGradient(0, 0, 0, 80);
        // // background: linear-gradient(180.28deg, rgba(171, 142, 245, 0.2) 0.38%, rgba(171, 142, 245, 0) 75.31%);
        //
        // gradient.addColorStop(0, hexToRgbA(color,0.6));
        // gradient.addColorStop(1, hexToRgbA(color,0));
        //
        // window.myChart = new Chart(ctx, {
        //     type: 'line',
        //     data: {
        //         labels: xaxis,
        //         datasets: [{
        //             // label: '# of Votes',
        //             data: yaxis,
        //             backgroundColor: gradient,
        //         }]
        //     },
        //     options: {
        //         responsive: true,
        //         legend: {
        //             display: false
        //         },
        //         elements: {
        //             line: {
        //                 borderColor: color,
        //                 borderWidth: 1
        //             },
        //             point: {
        //                 radius: 0
        //             }
        //         },
        //         tooltips: {
        //             enabled: false
        //         },
        //         scales: {
        //             yAxes: [
        //                 {
        //                     display: false,
        //                     beginAtZero: true
        //                 }
        //             ],
        //             xAxes: [
        //                 {
        //                     display: false
        //                 }
        //             ]
        //         },
        //         layout:{
        //             padding:0
        //         }
        //     }
        // });


    });

    const hexToRgbA = (hex,opacity) => {
        var c;
        if(/^#([A-Fa-f0-9]{3}){1,2}$/.test(hex)){
            c= hex.substring(1).split('');
            if(c.length== 3){
                c= [c[0], c[0], c[1], c[1], c[2], c[2]];
            }
            c= '0x'+c.join('');
            return 'rgba('+[(c>>16)&255, (c>>8)&255, c&255].join(',')+','+opacity+')';
        }
        throw new Error('Bad Hex');
    }

    const data = canvas => {
        const ctx = canvas.getContext('2d');
        var gradient = ctx.createLinearGradient(0, 0, 0, 80);
        // background: linear-gradient(180.28deg, rgba(171, 142, 245, 0.2) 0.38%, rgba(171, 142, 245, 0) 75.31%);

        gradient.addColorStop(0, hexToRgbA(color,0.6));
        gradient.addColorStop(1, hexToRgbA(color,0));

        return {
            labels: xaxis,
            datasets: [{
                // label: '# of Votes',
                data: yaxis,
                backgroundColor: gradient,
            }]
        };
    }

    const option= {
        responsive: true,
        legend: {
            display: false
        },
        elements: {
            line: {
                borderColor: color,
                borderWidth: 1
            },
            point: {
                radius: 0
            }
        },
        tooltips: {
            enabled: false
        },
        scales: {
            yAxes: [
                {
                    display: false,
                    beginAtZero: true
                }
            ],
            xAxes: [
                {
                    display: false
                }
            ]
        },
        layout:{
            padding:0
        }
    }


    return(
        <div className={"spark-graph-component"}
             style={{transform: "translateY(-35px)"}}
        >
            {/*<canvas id="myChart" width="100" height="67"/>*/}
            <Line
                height={170}
                // width={100}
                data={data}
                redraw={true}
                options={option}
            />
        </div>
    );
}

export default SparklineGraph;
